import { Badge } from '@/components/Badge';
import type { BadgeTone } from '@/components/Badge';
import { Card, CardBody, CardHeader, CardTitle } from '@/components/Card';
import type { MarginCheck, MarginStatus } from '@/domain/engine';

const STATUS_META: Record<MarginStatus, { tone: BadgeTone; label: string }> = {
  ok: { tone: 'ok', label: '通过' },
  warn: { tone: 'caution', label: '注意' },
  fail: { tone: 'critical', label: '不通过' },
  unknown: { tone: 'neutral', label: '数据不足' },
};

/** 裕度校验：电流、电池放电、悬停油门这些「能不能撑住」的检查 */
export function MarginList({ margins }: { margins: readonly MarginCheck[] }) {
  const problems = margins.filter((check) => check.status === 'fail').length;

  return (
    <Card className="print-keep">
      <CardHeader
        actions={
          problems > 0 ? (
            <Badge tone="critical" solid>
              {problems} 项不通过
            </Badge>
          ) : (
            <Badge tone="ok">全部可校验项通过</Badge>
          )
        }
      >
        <CardTitle subtitle="电流、放电能力与悬停余量">裕度校验</CardTitle>
      </CardHeader>
      <CardBody className="flex flex-col gap-2.5">
        {margins.length === 0 ? (
          <p className="text-xs text-fg-subtle">还没有可校验的项目。</p>
        ) : (
          margins.map((check) => {
            const meta = STATUS_META[check.status];
            return (
              <div key={check.id} className="flex flex-col gap-1 border-b border-line/60 pb-2 last:border-b-0 last:pb-0">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-xs font-medium text-fg">{check.label}</span>
                  <Badge tone={meta.tone} solid={check.status === 'fail'}>
                    {meta.label}
                  </Badge>
                </div>
                <p className="tabular text-[11px] leading-relaxed text-fg-muted">{check.detail}</p>
              </div>
            );
          })
        )}
      </CardBody>
    </Card>
  );
}
